import React from 'react';
import Divider from 'material-ui/Divider';
import TextField from 'material-ui/TextField';

const ForgotPasswordForm = props => {
    return (
        <div className="inputPageContainer">
            <div className="inputPage">
                <h1>Forgot Your Password?</h1>
                <h2>We'll send a link to your email so you can reset your password.</h2>
                <form onSubmit={props.handleSubmit}>
                    <TextField
                        hintText="Email"
                        underlineShow={false}
                        className="inputRow"
                        fullWidth={true}
                        type="email"
                        name="email"
                        value={props.email}
                        onChange={props.handleChange}
                    />
                    <Divider />
                    <button className="pink forgotButton">Send</button>
                </form>
                <p className="errorMessage">{props.errMsg}</p>
            </div>
        </div>
    );
}

export default ForgotPasswordForm;
